<template>
  <div class="lg:px-16 md:px-12 px-5 lg:py-12 md:py-12 py-8">
    <div
      class="bg-efe8f9 md:rounded-3xl lg:rounded-3xl rounded-lg md:p-8 lg:p-8 p-4 shadow-b-2xl relative"
    >
      <div class="">
        <b-form role="form">
          <div
            class="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-x-5 lg:gap-y-5 md:gap-y-6"
          >
            <div class="">
              <p class="input-title text-primary">Name</p>
              <base-input
                placeholder="Enter your Name"
                class="md:border-0 lg:border-0 custipshadow"
                name="First Name"
              ></base-input>
            </div>
            <div class="">
              <p class="input-title text-primary">Email</p>
              <base-input
                placeholder="Enter your Email"
                class="md:border-0 lg:border-0 custipshadow"
                name="First Name"
              ></base-input>
            </div>
            <div class="">
              <p class="input-title text-primary">Phone Number</p>
              <base-input
                placeholder="Enter your Phone Number"
                class="md:border-0 lg:border-0 custipshadow"
                name="First Name"
              ></base-input>
            </div>
            <div class="">
              <p class="input-title text-primary">Location</p>
              <base-input
                placeholder="Enter your Location"
                class="md:border-0 lg:border-0 custipshadow"
                name="First Name"
              ></base-input>
            </div>
            <div class="">
              <p class="input-title text-primary">What are you looking for?</p>
              <b-form-select
                v-model="art"
                placeholder="Select Artwork"
                class="md:border-0 lg:border-0 custipshadow"
                name="city"
              >
                <b-form-select-option :value="null"
                  >Please select an option</b-form-select-option
                >
                <b-form-select-option value="Poetry"
                  >Poetry</b-form-select-option
                >
                <b-form-select-option value="Photo">Photo</b-form-select-option>
                <b-form-select-option value="Video">Video</b-form-select-option>
                <b-form-select-option value="Prose" class="textcolor"
                  >Prose</b-form-select-option
                >
              </b-form-select>
            </div>
          </div>
          <div class="mt-8">
            <b-button
              type="submit"
              variant="primary"
              native-type="submit"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold"
              >Submit</b-button
            >
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
